// extracted by mini-css-extract-plugin
export default {"tableTitleCell":"WorkplaceInformation_tableTitleCell__UNqAX","shynar":"WorkplaceInformation_shynar__aw3-y"};